import {SHOW_LOADING} from '../actions/Loading';

const initialState = {
    show: false,
};

const LoadingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_LOADING:
            return {
                show: action.payload.show
            };
        default:
            return initialState;
    }
};


export default LoadingReducer;
